module.exports = __webpack_public_path__ + "img/x-b.e9d2c737.svg";